import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField } from "../../ui";
import DialogBox from "../../global/DialogBox";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { updateBillCustomerDetails } from "../../../store/billDetailsSlice";
import { INITIAL_BILL_CUSTOMER_DETAILS } from "../../../constants/restoConstant";
import { isEmpty } from "lodash";

const AddCustomerDetailsDialog = ({
  showDialog,
  setShowDialog,
  customerMobile,
}) => {
  const [customerDetails, setCustomerDetails] = useState({
    ...INITIAL_BILL_CUSTOMER_DETAILS,
    custMob: customerMobile,
  });

  const { billCustomerDetails } = useSelector((state) => state.bill);
  const dispatch = useDispatch();
  const { snackbar } = useSnpUI();

  useEffect(() => {
    if (showDialog) {
      setCustomerDetails({
        ...INITIAL_BILL_CUSTOMER_DETAILS,
        ...billCustomerDetails,
        custMob: isEmpty(customerMobile)
          ? billCustomerDetails?.custMob || ""
          : customerMobile,
      });
    }
  }, [showDialog, billCustomerDetails, customerMobile]);

  const handleAddCustomerDetails = () => {
    if (customerDetails?.custMob?.length === 10) {
      dispatch(updateBillCustomerDetails(customerDetails));
      setShowDialog(false);
    } else {
      snackbar.show({
        message: "Please Enter Correct Mobile Number",
        color: "red",
      });
    }
  };

  const handleDialogClose = () => {
    setShowDialog(false);
    setCustomerDetails({ ...INITIAL_BILL_CUSTOMER_DETAILS, custMob: "" });
  };

  const customerInputFields = () => (
    <div className="billing-cust-input-data">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            label="Customer Name"
            variant="filled"
            size="small"
            required
            value={customerDetails.custName}
            onChange={(e) =>
              setCustomerDetails({
                ...customerDetails,
                custName: e.target.value,
              })
            }
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Customer Mobile Number"
            variant="filled"
            size="small"
            disabled={
              (customerMobile?.length || 0) > 0 ||
              (billCustomerDetails?.custMob?.length || 0) > 0
            }
            required
            value={customerDetails.custMob}
            onChange={(e) =>
              setCustomerDetails({
                ...customerDetails,
                custMob: e.target.value,
              })
            }
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Customer Email Address"
            variant="filled"
            size="small"
            value={customerDetails.custEmail}
            onChange={(e) =>
              setCustomerDetails({
                ...customerDetails,
                custEmail: e.target.value,
              })
            }
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Customer Address"
            variant="filled"
            size="small"
            value={customerDetails.address}
            onChange={(e) =>
              setCustomerDetails({
                ...customerDetails,
                address: e.target.value,
              })
            }
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Customer GST Details"
            variant="filled"
            size="small"
            value={customerDetails.custGstDetails}
            onChange={(e) =>
              setCustomerDetails({
                ...customerDetails,
                custGstDetails: e.target.value,
              })
            }
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Customer Company Details"
            variant="filled"
            size="small"
            value={customerDetails.custCompanyName}
            onChange={(e) =>
              setCustomerDetails({
                ...customerDetails,
                custCompanyName: e.target.value,
              })
            }
            sx={{ width: "100%" }}
          />
        </Grid>
      </Grid>
    </div>
  );

  const customerInputDialogActions = () => (
    <>
      <SnpButton
        variant="contained"
        color="primary"
        onClick={handleAddCustomerDetails}
      >
        Add
      </SnpButton>
      <DismissButton
        variant="contained"
        color="primary"
        onClick={handleDialogClose}
      >
        Cancel
      </DismissButton>
    </>
  );

  return (
    <DialogBox
      showDialog={showDialog}
      title="Enter Customer Details"
      onClose={handleDialogClose}
      dialogContent={customerInputFields()}
      dialogActions={customerInputDialogActions()}
    />
  );
};

export default AddCustomerDetailsDialog;